import { TablaHtml } from "../entities/tabla-html";
import { Constantes } from '../../shared/constant/constantes';
import { CompromisosXFecha } from "../entities/CompromisosXFecha";
import { Compromiso } from "../entities/Compromiso";

export class UtilidadCalendario {

  public constantes: Constantes = new Constantes();

  public generaRangoAnnios(rango: number, filas: number): Array<TablaHtml> {
    var result: Array<TablaHtml> = new Array();
    var valActual: number = new Date().getFullYear();
    var ranIni = valActual - rango;
    var ranFin = valActual + rango;
    var j = 1;
    var listaAnnio: TablaHtml = new TablaHtml();
    for (var i = ranIni; i <= ranFin; i++) {
      var annio: TablaHtml = new TablaHtml();
      annio.id = "td_annio_" + i;
      annio.descripcion = '' + i;
      if (i === valActual) {
        annio.estiloClase = 'celdaMenuSeleccion';
      } else {
        annio.estiloClase = 'celdaMenuSinSeleccion';
      }
      listaAnnio.hijosHtml.push(annio);
      if (j < filas) {
        j++;
      } else {
        result.push(listaAnnio);
        listaAnnio = new TablaHtml();
        j = 1;
      }
    }
    return result;
  }

  public generaRangoMeses(annioSelect: number, filas: number): Array<TablaHtml> {
    var result: Array<TablaHtml> = new Array();
    var annioActual: number = new Date().getFullYear();
    var mesActual: number = new Date().getMonth();
    var j = 1;
    var listaMes: TablaHtml = new TablaHtml();
    for (var i = 0; i <= this.constantes.MESES_ANNIO.length; i++) {
      var mes: TablaHtml = new TablaHtml();
      mes.id = '' + (i + 1);
      mes.descripcion = '' + this.constantes.MESES_ANNIO[i];
      if (i == mesActual && annioActual == annioSelect) {
        mes.estiloClase = 'celdaMenuSeleccion';
      } else {
        mes.estiloClase = 'celdaMenuSinSeleccion';
      }
      listaMes.hijosHtml.push(mes);
      if (j < filas) {
        j++;
      } else {
        result.push(listaMes);
        listaMes = new TablaHtml();
        j = 1;
      }
    }
    return result;
  }

  public getCategorias(): Map<number, string> {
    let categorias: Map<number, string> = new Map();
    categorias.set(1, 'Actividad económica y mercado laboral');
    categorias.set(2, 'Precios e inflación');
    categorias.set(3, 'Reservas internacionales y operaciones del Banco en el mercado');
    categorias.set(4, 'Sector Fiscal');
    categorias.set(5, 'Tasas de cambio y sector externo');
    categorias.set(6, 'Tasas de interés y sector financiero');
    return categorias;
  }

  public getDiasSemanaCalendario(): Map<number, string> {
    let mapaDias: Map<number, string> = new Map();
    mapaDias.set(1, 'Lunes');
    mapaDias.set(2, 'Martes');
    mapaDias.set(3, 'Miercoles');
    mapaDias.set(4, 'Jueves');
    mapaDias.set(5, 'Viernes');
    return mapaDias;
  }

  public getNumeroDiasMes(año: number, mes: number): number {
    var date = new Date(año, mes - 1, 1);
    var month = date.getMonth();
    var numeroDias: number = 0;
    while (date.getMonth() == month) {
      numeroDias++;
      date.setDate(date.getDate() + 1);
    }
    return numeroDias;
  }

  public getPrimerDiaMes(año: number, mes: number) {
    var date = new Date(año, mes - 1, 1);
    return date.getDay();
  }

  public getNumeroDiasMesAnterior(año: number, mes: number) {
    if (mes == 1)
      return this.getNumeroDiasMes(año - 1, 12);
    return this.getNumeroDiasMes(año, mes - 1);
  }

  public armarTablaDiasMes(annio_sel: number, mes_sel: number, feriados: Array<any>): Array<TablaHtml> {
    var rango_dias: Array<TablaHtml> = new Array();
    var numeroDias = this.getNumeroDiasMes(annio_sel, mes_sel);
    var numeroDiasMesAnterior = this.getNumeroDiasMesAnterior(annio_sel, mes_sel);
    var primerDia = this.getPrimerDiaMes(annio_sel, mes_sel);
    var diasMesAnterior = numeroDiasMesAnterior - primerDia + 1;

    var annioActual: number = new Date().getFullYear();
    var mesActual: number = new Date().getMonth() + 1;
    var diaActual: number = new Date().getDate();
    var semanas = 4;
    if (numeroDias == 28 && primerDia > 0)
      semanas = 5;
    if (numeroDias > 28)
      semanas = 5;
    if (numeroDias == 30 && primerDia >= 6)
      semanas = 5;
    if (numeroDias >= 31 && primerDia >= 5)
      semanas = 6;

    let filaDia: TablaHtml;
    for (var i = 0; i < semanas; i++) {
      filaDia = new TablaHtml();
      filaDia.estiloClase = 'celdaMenu';
      let celdaDia: TablaHtml = new TablaHtml();
      for (var j = 1; j <= 7; j++) {
        let idCelda = i * 7 + j;
        celdaDia = new TablaHtml();
        celdaDia.id = 'td_dia_' + idCelda;
        filaDia.hijosHtml.push(celdaDia);
      }
      rango_dias.push(filaDia);
    }

    for (var i = primerDia + 1, j = 1; j <= numeroDias; i++, j++) {
      var idDia = "td_dia_" + i;
      rango_dias.forEach((f) => {
        f.hijosHtml.forEach((d) => {
          if (d.id == idDia) {
            d.descripcion = j + "";
            if (feriados.indexOf(mes_sel + "-" + j) >= 0) {
              d.estiloClase = "diaFestivo";
            }
          }
        });
      });
    }

    for (var i = 0; i < rango_dias.length; i++) {
      var celdas = rango_dias[i].hijosHtml;
      for (var j = 0, k = 1; j < celdas.length; j++, k++) {
        if (celdas[j].descripcion != "") {
          var dato = celdas[j].descripcion;
          celdas[j].id = "td_dia_" + dato;
          celdas[j].isEvento = true;

          if (diaActual == parseInt(dato) && mesActual == mes_sel && annioActual == annio_sel) {
            celdas[j].estiloClase = 'celdaMenuSeleccion';
          } else {
            celdas[j].estiloClase = 'celdaMenuSinSeleccion';
          }

          k = 0;
        } else {
          if (i == 0) {
            let diaAnterior = diasMesAnterior + j;
            celdas[j].descripcion = "" + diaAnterior;
            celdas[j].id = '';
            celdas[j].estiloClase = "diaMesAnteriorSiguiente";
          } else {
            celdas[j].descripcion = "" + k;
            celdas[j].id = '';
            celdas[j].estiloClase = "diaMesAnteriorSiguiente";
          }
        }
      }
    }
    return rango_dias;
  }

  public getNombreMes(fecha: Date): string {
    return this.constantes.MESES_ANNIO[fecha.getMonth()];
  }

  /******************************************************************************* */
  /****************************FUNCIONES LUIS OROZCO****************************** */
  /******************************************************************************* */
  public generaListaSemana(lista: Array<Compromiso>, paramFecha: Date, listaFestivos: string[]): Array<CompromisosXFecha> {
    var listaResult: Array<CompromisosXFecha> = new Array();

    var fechaDiaUno = new Date(paramFecha);
    var fechaDiaDos = this.sumarDias(paramFecha, 1);
    var fechaDiaTres = this.sumarDias(paramFecha, 2);
    var fechaDiaCuatro = this.sumarDias(paramFecha, 3);
    var fechaDiaCinco = this.sumarDias(paramFecha, 4);

    var listaCompromisoUno: Array<any> = new Array();
    var listaCompromisoDos: Array<any> = new Array();
    var listaCompromisoTres: Array<any> = new Array();
    var listaCompromisoCuatro: Array<any> = new Array();
    var listaCompromisoCinco: Array<any> = new Array();

    if (lista != undefined) {
      lista.forEach(compromiso => {
        var fechaCompromiso = new Date(compromiso.fechaCompleta);
        compromiso.estilo = this.getEstiloCategoria(compromiso.categoriaNivel1);
        compromiso.tituloFechaCorte = this.generaTituloFechaCorte(compromiso);
        if (fechaDiaUno.getMonth() == fechaCompromiso.getMonth() &&
          fechaDiaUno.getDate() == fechaCompromiso.getDate() &&
          fechaDiaUno.getFullYear() == fechaCompromiso.getFullYear()) {
          listaCompromisoUno.push(compromiso);
        } else if (fechaDiaDos.getMonth() == fechaCompromiso.getMonth() &&
          fechaDiaDos.getDate() == fechaCompromiso.getDate() &&
          fechaDiaDos.getFullYear() == fechaCompromiso.getFullYear()) {
          listaCompromisoDos.push(compromiso);
        } else if (fechaDiaTres.getMonth() == fechaCompromiso.getMonth() &&
          fechaDiaTres.getDate() == fechaCompromiso.getDate() &&
          fechaDiaTres.getFullYear() == fechaCompromiso.getFullYear()) {
          listaCompromisoTres.push(compromiso);
        } else if (fechaDiaCuatro.getMonth() == fechaCompromiso.getMonth() &&
          fechaDiaCuatro.getDate() == fechaCompromiso.getDate() &&
          fechaDiaCuatro.getFullYear() == fechaCompromiso.getFullYear()) {
          listaCompromisoCuatro.push(compromiso);
        } else if (fechaDiaCinco.getMonth() == fechaCompromiso.getMonth() &&
          fechaDiaCinco.getDate() == fechaCompromiso.getDate() &&
          fechaDiaCinco.getFullYear() == fechaCompromiso.getFullYear()) {
          listaCompromisoCinco.push(compromiso);
        }
      });
    }
    var compFecha: CompromisosXFecha = new CompromisosXFecha();
    compFecha.fecha = fechaDiaUno;
    if (this.isFechaHoy(fechaDiaUno)) {
      compFecha.esHoy = 'SI';
      compFecha.estiloHoy = 'div-tabla-encabezado-hoy';
    }
    compFecha.titulo = this.getTituloDiaSemana(fechaDiaUno);
    compFecha.estiloFestivo = this.validaFestivo(fechaDiaUno, listaFestivos);
    compFecha.listaCompromisos = compFecha.listaCompromisos.concat(listaCompromisoUno.sort(function (a, b) {
      const horaA = a.ordenPublicacion;
      const horaB = b.ordenPublicacion;
      if (horaA < horaB) {
        return -1
      }
      if (horaA > horaB) {
        return 1
      }
      return 0;
    }));
    listaResult.push(compFecha);

    var compFecha: CompromisosXFecha = new CompromisosXFecha();
    compFecha.fecha = fechaDiaDos;
    if (this.isFechaHoy(fechaDiaDos)) {
      compFecha.esHoy = 'SI';
      compFecha.estiloHoy = 'div-tabla-encabezado-hoy';
    }
    compFecha.titulo = this.getTituloDiaSemana(fechaDiaDos);
    compFecha.estiloFestivo = this.validaFestivo(fechaDiaDos, listaFestivos);
    compFecha.listaCompromisos = compFecha.listaCompromisos.concat(listaCompromisoDos.sort(function (a, b) {
      const horaA = a.ordenPublicacion;
      const horaB = b.ordenPublicacion;
      if (horaA < horaB) {
        return -1
      }
      if (horaA > horaB) {
        return 1
      }
      return 0;
    }));
    listaResult.push(compFecha);

    var compFecha: CompromisosXFecha = new CompromisosXFecha();
    compFecha.fecha = fechaDiaTres;
    if (this.isFechaHoy(fechaDiaTres)) {
      compFecha.esHoy = 'SI';
      compFecha.estiloHoy = 'div-tabla-encabezado-hoy';
    }
    compFecha.titulo = this.getTituloDiaSemana(fechaDiaTres);
    compFecha.estiloFestivo = this.validaFestivo(fechaDiaTres, listaFestivos);
    compFecha.listaCompromisos = compFecha.listaCompromisos.concat(listaCompromisoTres.sort(function (a, b) {
      const horaA = a.ordenPublicacion;
      const horaB = b.ordenPublicacion;
      if (horaA < horaB) {
        return -1
      }
      if (horaA > horaB) {
        return 1
      }
      return 0;
    }));
    listaResult.push(compFecha);

    var compFecha: CompromisosXFecha = new CompromisosXFecha();
    compFecha.fecha = fechaDiaCuatro;
    if (this.isFechaHoy(fechaDiaCuatro)) {
      compFecha.esHoy = 'SI';
      compFecha.estiloHoy = 'div-tabla-encabezado-hoy';
    }
    compFecha.titulo = this.getTituloDiaSemana(fechaDiaCuatro);
    compFecha.estiloFestivo = this.validaFestivo(fechaDiaCuatro, listaFestivos);
    compFecha.listaCompromisos = compFecha.listaCompromisos.concat(listaCompromisoCuatro.sort(function (a, b) {
      const horaA = a.ordenPublicacion;
      const horaB = b.ordenPublicacion;
      if (horaA < horaB) {
        return -1
      }
      if (horaA > horaB) {
        return 1
      }
      return 0;
    }));
    listaResult.push(compFecha);

    var compFecha: CompromisosXFecha = new CompromisosXFecha();
    compFecha.fecha = fechaDiaCinco;
    if (this.isFechaHoy(fechaDiaCinco)) {
      compFecha.esHoy = 'SI';
      compFecha.estiloHoy = 'div-tabla-encabezado-hoy';
    }
    compFecha.titulo = this.getTituloDiaSemana(fechaDiaCinco);
    compFecha.estiloFestivo = this.validaFestivo(fechaDiaCinco, listaFestivos);
    compFecha.listaCompromisos = compFecha.listaCompromisos.concat(listaCompromisoCinco.sort(function (a, b) {
      const horaA = a.ordenPublicacion;
      const horaB = b.ordenPublicacion;
      if (horaA < horaB) {
        return -1
      }
      if (horaA > horaB) {
        return 1
      }
      return 0;
    }));
    listaResult.push(compFecha);
    return listaResult;
  }

  public generaListaMes(lista: Array<Compromiso>, fechaMes: Date, listaFestivos: string[]): Array<CompromisosXFecha> {
    var listaResult: Array<CompromisosXFecha> = new Array();

    var mapaCompromiso: Map<string, Array<Compromiso>> = new Map();
    var primerDia = new Date(fechaMes.getFullYear(), fechaMes.getMonth(), 1);
    var ultimoDia = new Date(fechaMes.getFullYear(), fechaMes.getMonth() + 1, 0);
    if (lista != undefined) {
      lista.forEach(compromiso => {
        var fechaCompromiso = new Date(compromiso.fechaCompleta);
        compromiso.estilo = this.getEstiloCategoria(compromiso.categoriaNivel1);
        compromiso.tituloFechaCorte = this.generaTituloFechaCorte(compromiso);
        if (primerDia.getMonth() == fechaCompromiso.getMonth() &&
          primerDia.getFullYear() == fechaCompromiso.getFullYear() &&
          (fechaCompromiso.getDate() >= primerDia.getDate() ||
            fechaCompromiso.getDate() <= ultimoDia.getDate())) {
          var llaveFecha: string = this.getKeyDate(fechaCompromiso);
          var listaCom: Array<Compromiso> = new Array();
          listaCom.push(compromiso);

          if (mapaCompromiso.get(llaveFecha) == undefined) {
            mapaCompromiso.set(llaveFecha, listaCom);
          } else {
            var listaFromMapa = mapaCompromiso.get(llaveFecha);
            listaFromMapa = listaFromMapa!.concat(listaCom);
            mapaCompromiso.set(llaveFecha, listaFromMapa.sort(function (a, b) {
              const horaA = a.ordenPublicacion;
              const horaB = b.ordenPublicacion;
              if (horaA < horaB) {
                return -1
              }
              if (horaA > horaB) {
                return 1
              }
              return 0;
            }));
          }
        }
      });
    }
    for (var i = 0; i <= ultimoDia.getDate(); i++) {
      var fecha = this.sumarDias(primerDia, i);
      var dia = this.getDiasSemanaCalendario().get(fecha.getDay());
      if (dia != undefined) {
        var llaveFecha: string = this.getKeyDate(fecha);
        if (mapaCompromiso.get(llaveFecha) != undefined) {
          var compFecha: CompromisosXFecha = new CompromisosXFecha();
          compFecha.fecha = fecha;
          compFecha.id = fecha.getDate() + '' + fecha.getMonth() + '' + fecha.getFullYear();
          if (this.isFechaHoy(fecha)) {
            compFecha.esHoy = 'SI';
            compFecha.estiloHoy = 'div-tabla-encabezado-hoy-lista';
          }
          compFecha.titulo = this.getTituloDiaSemana(fecha);
          compFecha.estiloFestivo = this.validaFestivo(fecha, listaFestivos);
          compFecha.listaCompromisos = compFecha.listaCompromisos.concat(mapaCompromiso.get(llaveFecha));
          listaResult.push(compFecha);
        }
      }
    }
    return listaResult;
  }

  public sumarDias(fecha: Date, dias: number): Date {
    var resultado = new Date(fecha);
    resultado.setDate(resultado.getDate() + dias);
    return resultado;
  }

  public restarDias(fecha: Date, dias: number): Date {
    var resultado = new Date(fecha);
    resultado.setDate(resultado.getDate() - dias);
    return resultado;
  }

  public sumarMeses(fecha: Date, meses: number): Date {
    var resultado = new Date(fecha);
    resultado.setMonth(resultado.getMonth() + meses);
    return resultado;
  }

  public restarMeses(fecha: Date, meses: number): Date {
    var resultado = new Date(fecha);
    resultado.setMonth(resultado.getMonth() - meses);
    return resultado;
  }

  public getTituloDiaSemana(fecha: Date): string {
    var titulo: string = '';
    var nombreMes = this.getNombreMes(fecha)
    titulo = this.getDiasSemanaCalendario().get(fecha.getDay()) + " " + fecha.getDate() + " de " + nombreMes;
    return titulo;
  }

  private getEstiloCategoria(categoria: string): string {
    var estilo: string = '';
    switch (categoria) {
      case 'Actividad económica y mercado laboral':
        estilo = 'div-imagen-actividad-economica';
        break;
      case 'Precios e inflación':
        estilo = 'div-imagen-precios-inflacion';
        break;
      case 'Reservas internacionales y operaciones del Banco en el mercado':
        estilo = 'div-imagen-reservas-internacionales';
        break;
      case 'Sector Fiscal':
        estilo = 'div-imagen-sector-publico';
        break;
      case 'Tasas de cambio y sector externo':
        estilo = 'div-imagen-tasa-cambio';
        break;
      case 'Tasas de interés y sector financiero':
        estilo = 'div-imagen-tasa-interes';
        break;
      default:
        break;
    }
    return estilo;
  }

  public getKeyDate(fecha: Date): string {
    var resultado = fecha.getDate() + '-' + fecha.getMonth() + '-' + fecha.getFullYear();
    return resultado;
  }

  public generaEncabezadoSemana(paramFechaInicial: Date, paramFechaFinal: Date): string {
    var diaMesInicial = paramFechaInicial.getDate();
    var diaMesFinal = paramFechaFinal.getDate();
    if (paramFechaInicial.getMonth() == paramFechaFinal.getMonth()) {
      return diaMesInicial + " - " + diaMesFinal + " de " + this.getNombreMes(paramFechaInicial) + " de " + paramFechaFinal.getFullYear();
    } else {
      return diaMesInicial + " de " + this.getNombreMes(paramFechaInicial) + " - " + diaMesFinal + " de " + this.getNombreMes(paramFechaFinal) + " de " + paramFechaFinal.getFullYear();
    }
  }

  public generaEncabezadoMes(paramFecha: Date): string {
    return this.getNombreMes(paramFecha) + " de " + paramFecha.getFullYear();
  }

  public getKeyByValue(map: Map<number, string>, nombre: string):any {
    for (let [key, value] of map.entries()) {
      if (value == nombre) {
        return key;
      }
    }
  }

  private isFechaHoy(fechaParam: Date): boolean {
    var result: boolean = false;
    var fechaHoy = new Date();
    if (fechaParam.getFullYear() == fechaHoy.getFullYear() &&
      fechaParam.getMonth() == fechaHoy.getMonth() &&
      fechaParam.getDate() == fechaHoy.getDate()) {
      result = true;
    } else {
      result = false;
    }
    return result;
  }

  private validaFestivo(fecha: Date, listaFestivos: string[]): string {
    var estiloResult = '';
    listaFestivos.forEach(festivo => {
      let f = festivo.substring(0, 10);
      var fechaFestivo = new Date(f.replace('-', '/'));
      if (fechaFestivo.getFullYear() == fecha.getFullYear() && fechaFestivo.getMonth() == fecha.getMonth() && fechaFestivo.getDate() == fecha.getDate()) {
        estiloResult = 'div-tabla-encabezado-festivo';
      }
    });
    return estiloResult;
  }

  //se debe cambiar la fecha desde por fecha hasta
  private generaTituloFechaCorte(compromiso: Compromiso): string {
    var resultado = '';
    if (compromiso.periodicidad === 'TRIMESTRAL') {
      var quarter = Math.ceil((new Date(compromiso.fechaHasta).getMonth() + 1) / 3);
      resultado = 'Publicación para datos con fecha de corte trimestre ' + quarter + ' de ' + new Date(compromiso.fechaHasta).getFullYear();
    } else if (compromiso.periodicidad === 'MENSUAL') {
      var mes = this.constantes.MESES_ANNIO[new Date(compromiso.fechaHasta).getMonth()];
      resultado = 'Publicación para datos con fecha de corte ' + mes + ' de ' + new Date(compromiso.fechaHasta).getFullYear();
    } else {
      var dia = new Date(compromiso.fechaHasta).getDate();
      var mes = this.constantes.MESES_ANNIO[new Date(compromiso.fechaHasta).getMonth()];
      resultado = 'Publicación para datos con fecha de corte ' + dia + ' de ' + mes + ' de ' + new Date(compromiso.fechaHasta).getFullYear();
    }
    return resultado;
  }
}